"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseUri = require("../Support/BaseUri");
var _q = require("../Support/Query");
function colorway(_a) {
    var designCode = _a.designCode, colorCode = _a.colorCode, tileWidth = _a.tileWidth, tileHeight = _a.tileHeight, variation = _a.variation, tileQuery = __rest(_a, ["designCode", "colorCode", "tileWidth", "tileHeight", "variation"]);
    return BaseUri.compose()
        .segment([
        'designs', designCode,
        'colors', colorCode,
        'tiles', tileWidth + "x" + tileHeight,
        "" + (variation || 1)
    ])
        .query(parseTileArgs(tileQuery))
        .toString();
}
exports.colorway = colorway;
function recolor(_a) {
    var designCode = _a.designCode, tileWidth = _a.tileWidth, tileHeight = _a.tileHeight, variation = _a.variation, rotation = _a.rotation, pixels = _a.pixels, recolorArgs = __rest(_a, ["designCode", "tileWidth", "tileHeight", "variation", "rotation", "pixels"]);
    return BaseUri.compose()
        .segment([
        'designs', designCode, 'recolor',
        'tiles', tileWidth + "x" + tileHeight,
        "" + (variation || 1)
    ])
        .query(__assign({}, _q.recolor(recolorArgs), parseTileArgs({ rotation: rotation, pixels: pixels })))
        .toString();
}
exports.recolor = recolor;
function parseTileArgs(_a) {
    var rotation = _a.rotation, pixels = _a.pixels;
    return __assign({}, _q.parseArg('rotation', rotation), _q.parseArg('pixels', pixels));
}
